import { recoilPersist } from "recoil-persist"

const { persistAtom } = recoilPersist({
  storage: sessionStorage
})

export const persistAtomEffect = (param) => {
  persistAtom(param);
}
